<template>
  <div dir="ltr" style="overflow: hidden; position: relative;">
    <v-navigation-drawer width="140px" v-model="positionSidebar" absolute right class="drawer">
      <v-container no-gutters class="pa-0">
        <v-row no-gutters class="drawer-header px-4 justify-center">
          <v-col class="flex items-center justify-start">
            <div class="drawer-header-title">نواحی</div>
          </v-col>
          <v-col class="flex items-center justify-end">
            <v-btn dense small icon @click="positionSidebar = false">
              <v-icon>mdi-chevron-right mdi-16px</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="drawer-body px-4">
          <v-col>
            <v-checkbox dir="rtl" hide-details v-for="{ id, title } in allZones" :key="id" :value="id" :label="title"
              v-model="selectedZones" />
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card height="52px" elevation="24" class="search-card">
          <v-card-text class="py-1 px-4">
            <v-row no-gutters dir="rtl" class="items-center">
              <v-col cols="1">
                <v-btn @click="positionSidebar = true" dense icon>
                  <v-icon>mdi-menu-open mdi-18px</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="8" class="pa-0">
                <!-- <v-text-field
                  hide-details
                  rounded
                  clearable
                  small
                  dense
                  clear-icon="mdi-close-circle-outline"
                  append-icon="mdi-magnify"
                  outlined
                  v-on:keyup.enter="searchForAddress()"
                  placeholder="جستجو..."
                  @click:clear="clearSearchCode()"
                  v-model="searchAddress"
                ></v-text-field> -->
                <map-search-field @address-search="onSearchSuggestion" :maxMinSearchProp="false" />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <v-row no-gutters class="">
                  <v-col cols="2" class="flex items-center">
                    <div>کد</div>
                  </v-col>
                  <v-col cols="10">
                    <v-text-field rounded hide-details clearable type="number" dense outlined
                      clear-icon="mdi-close-circle-outline" placeholder="کد" v-on:keyup.enter="searchForCode()"
                      v-model="searchCode" @click:clear="clearSearchCode()"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <!--map-->
      <v-col cols="12">
        <div id="map" class="dispatch-map">
          <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 93vh !important" :zoom="zoom" :center="center"
            :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="mapInvalidate()">
            <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
            <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
            <l-control position="topright">
              <div>
                <div class="mb-3">
                  <v-btn icon small tile class="no-letter-space" @click="showHideFence()" style="
                      background-color: white;
                      border: solid;
                      border-width: 2px;
                      border-radius: 5px;
                      border-color: #c2bfba;
                      padding: 15px;
                    ">
                    <v-icon>mdi-layers</v-icon>
                  </v-btn>
                </div>
                <div>
                  <v-btn icon small tile class="no-letter-space" style="
                      background-color: white;
                      border: solid;
                      border-width: 2px;
                      border-radius: 5px;
                      border-color: #c2bfba;
                      padding: 15px;
                    " @click="toggleShowingStations">
                    <v-icon>mdi-home-group mdi-24px</v-icon>
                  </v-btn>
                </div>
              </div>
            </l-control>
            <template v-if="showingStationsList?.length">
              <l-marker v-for="station in showingStationsList" :key="station.id"
                :lat-lng="[station?.latitude, station?.longitude]" :icon="stationIcon()">
                <v-popup>
                  <div dir="rtl" class="mt-5">
                    <app-conversation question="نام پایگاه" :answer="station?.title"></app-conversation>
                    <app-conversation question="کد پایگاه" :answer="station?.code"></app-conversation>
                  </div>
                </v-popup>
                <!-- <l-icon
                  icon-url="/icons/map/shield-home.svg"
                  :icon-size="[22,22]"
                  :icon-anchor="[11,11]"
                >
                </l-icon> -->
              </l-marker>
            </template>
            <l-marker v-for="(item, index) in filteredPositions" :key="index + 'a'"
              :lat-lng="[item?.latitude, item?.longitude]" :icon="getMovingIcon(item)">
              <l-tooltip :options="{ permanent: true, interactive: true }">
                {{ item.phone && item.phone.code ? item.phone.code : '-' }}
              </l-tooltip>
              <!-- <v-popup :lat-lng="[item.latitude, item.longitude]"> -->
              <v-popup :options="{ autoPan: false }">
                <template v-for="({ value }, index) in getPopUpInfoList(item)">
                  <div v-if="value" :key="index" class="text-right pr-3" :class="index == 0 ? 'mt-4' : 'mt-2'">
                    {{ value }}
                  </div>
                </template>
              </v-popup>
            </l-marker>

            <l-polygon v-for="(item, index) in fenceCoords" :key="index" :lat-lngs="item.latlngs" :color="item.color"
              :fillColor="item.color">
              <v-popup :options="{ offset: [5, -8] }">
                <h4 class="mt-5 font-bold text-center fontFamilySET">{{ item.title }}</h4>
                <h4 v-if="item.moreInfo?.length > 0" style="font-weight: 400;direction: rtl;"
                  class="fontFamilySET text-right mt-2">
                  فاقدی ها : </h4>
                <v-list dense>
                  <v-list-item dense v-for="lake in item.moreInfo" :key="lake.id" class="mt-n3">
                    <v-list-item-title class="text-right fontFamilySET">{{ lake.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-popup>
            </l-polygon>
          </l-map>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Vue from 'vue';
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip, LControl, LPolygon, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import ShearedMixin from '@/Mixins/Shared.js';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin.js';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin.js';
import StationCoverageZoneMixin from '@/Mixins/BaseInformation/StationCoverageZoneMixin';
import StationMixin from '@/Mixins/BaseInformation/StationMixin';
import MapMixin from '@/Mixins/115/MapMixin';
import MapHelper from '@/Helpers/800/Map.helper.js';
import SharedMap from '@/Mixins/map';
import SharedHelper from '@/Helpers/Shared';
import AppConversation from '@/components/app/conversation.vue';
import MapSearchField from '@/components/app/map/search.vue';
import SerachMapMixin from '@/components/app/map/SerachMapMixin.js';
import CryptoJS from 'crypto-js';

export default {
  title: 'نقشه پیگیری',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControl,
    LPolygon,
    'v-popup': LPopup,
    AppConversation,
    MapSearchField,
  },
  mixins: [
    ShearedMixin,
    PhoneOnlineLocationMixin,
    ZoneMixin,
    StationCoverageZoneMixin,
    MapMixin,
    MapHelper,
    SharedMap,
    SharedHelper,
    StationMixin,
    SerachMapMixin,
  ],
  created() {
    this.$root.$refs.followUpMap = this;
    Vue.prototype.$mainSignalr.start();
    Vue.prototype.$mobileSignalr.start();
  },
  mounted() {
    this.mounteLoding();
    this.mapInterval = setInterval(() => {
      let bytes = CryptoJS.AES.decrypt(localStorage.getItem('dash'), 'f9rr8Y2D96Klh87N');
      let moduleId = '';
      if (bytes.sigBytes != 0) {
        moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        moduleId = '';
      }
      if (moduleId != 7) {
        window.close();
      }
    }, 4000);
    // this.interval();
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: [],
      dragging: false,
      icon: this.getIcon,
      mapInterval: null,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      fenceCoords: [],
      tempFenceCoords: [],
      fenceFlag: true,
      searchZoneIds: [],
      searchAddress: '',
      searchCode: '',
      allPhonesPositions: [],
      counter: 0,
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getAllStationCoverageZonesForAllStations();
      this.getAllPhoneOnlineLocationFunction();
      this.getSystemSettingByClientComputer();
      this.setMapBaseSystemSetting();
      this.getAllStations();
      setInterval(() => this.getAllPhoneOnlineLocationFunction(), 4000);
      this.$mainSignalr.bus.$on('Location', this.fLocation);
      // setTimeout(()=>{
      // },3000);
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    getMovingIcon(data) {
      if (data.speed >= 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        }
      }
    },
    stationIcon: function () {
      return L.divIcon({
        className: 'my-custom-pin',
        html: '<img src="/icons/map/ems_logo.svg" style="width:28px; height:28px;"/>',
      });
    },
    getDateDifference: function (fromDate) {
      const nowSeconds = new Date()?.getTime();
      const fromDateSecondes = new Date(fromDate)?.getTime();
      const difference = Math.abs(nowSeconds - fromDateSecondes);
      return this.convertSecondsToHHMMss(difference / 1000);
    },
    getPopUpInfoList: function (item) {
      return [
        {
          id: 2,
          title: 'وضعیت فعلی',
          value: item?.phone?.currentStatus,
        },
        {
          id: 3,
          title: 'زمان آخرین تراکنش',
          value: this.getDateDifference(item?.locationDateTime),
        },
      ];
    },
    readyFencesForMap: function (data) {
      this.fenceCoords = [];
      for (let i = 0; i < data.length; i++) {
        let tempFence = {
          latlngs: [],
          color: data[i].fenceColor,
          moreInfo: [],
          id: data[i].id,
          title: data[i].title,
        };
        for (let j = 0; j < data[i].stationCoverageZoneFences.length; j++) {
          let info = [];
          info.push(data[i].stationCoverageZoneFences[j].latitude);
          info.push(data[i].stationCoverageZoneFences[j].longitude);
          tempFence.latlngs.push(info);
        }
        for (let j = 0; j < data[i].stationCoverageZoneSupportStations.length; j++) {
          let title = data[i].stationCoverageZoneSupportStations[j].station
            ? data[i].stationCoverageZoneSupportStations[j].station.title
            : '-';
          tempFence.moreInfo.push({
            title: title,
            id: data[i].stationCoverageZoneSupportStations[j].id,
          });
        }
        this.fenceCoords.push(tempFence);
      }
    },
    showHideFence: function () {
      if (this.fenceFlag == true) {
        this.fenceFlag = false;
        this.tempFenceCoords = [];
        for (let i = 0; i < this.fenceCoords.length; i++) {
          this.tempFenceCoords.push(this.fenceCoords[i]);
        }
        this.fenceCoords = [];
      } else if (this.fenceFlag == false) {
        this.fenceFlag = true;
        this.fenceCoords = [];
        for (let i = 0; i < this.tempFenceCoords.length; i++) {
          this.fenceCoords.push(this.tempFenceCoords[i]);
        }
        this.tempFenceCoords = [];
      }
    },
    readyCodeData: function () {
      this.allPhonesPositions = [];
      if (this.searchZoneIds.length > 0) {
        for (let i = 0; i < this.searchZoneIds.length; i++) {
          for (let j = 0; j < this.allPhoneOnlineLocations.length; j++) {
            if (this.searchZoneIds[i] == this.allPhoneOnlineLocations[j].phone.zoneId) {
              this.allPhonesPositions.push(this.allPhoneOnlineLocations[j]);
            }
          }
        }
      } else {
        this.allPhonesPositions = this.allPhoneOnlineLocations;
      }
    },
    searchForCode: function () {
      if (this.searchCode) {
        let searchObject = this.allPhoneOnlineLocations.find(
          (c) => c.phone.code == this.searchCode,
        );
        this.$refs.modalmap.mapObject.flyTo([searchObject.latitude, searchObject.longitude], 16);
      } else {
        this.clearSearchCode();
      }
    },
    clearSearchCode: function () {
      const lat = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLatitude;
      const lng = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLongitude;
      const zoom = this.$store.state.SystemSettingModule.systemSetting?.mapDefaultZoomLevel;
      if (lat && lng) {
        this.$refs.modalmap.mapObject.flyTo([lat, lng], zoom ?? 12);
      }
    },
    searchForAddress: function () {
      if (this.searchAddress) {
        this.getMapGeoCode(this.searchAddress);
      } else {
        this.clearSearchCode();
      }
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 16);
    },
    flyToCode: function (data) {
      console.log(data);
    },
    fLocation(data) {
      if (this.$store.state.userModule.userId == data?.data?.userId) {
        for (const item of this.allPhonesPositions) {
          if (data?.data?.code == item.phone.code) {
            this.$refs.modalmap.mapObject.flyTo([item.latitude, item.longitude], 17);
          }
        }
      }
    },
    // test:function(){
    //   this.allPhonesPositions=[...this.allPhonesPositions]?.map((item)=>({...item,latitude:item?.latitude+0.0001}))
    // }
  },
  beforeDestroy() {
    clearInterval(this.mapInterval);
    this.$mainSignalr.bus.$off('Location', this.fLocation);
  },
};
</script>
<style lang="scss">
.dispatch-map {
  .leaflet-popup-content {
    margin: 0.5rem !important;
  }
}
</style>
<style lang="scss" scoped>
.drawer {
  direction: rtl;
  z-index: 2000;

  &-header {
    background-color: var(--background-color);
    height: 52px;

    &-title {
      font-size: 16px;
      font-weight: 600;
    }
  }
}

.search-card {
  background: var(--background-color) !important;
  border-radius: 0px !important;
}

>>>.leaflet-tooltip {
  opacity: 0.6 !important;
}
</style>
